import {
  updateSpecifiedLocation,
} from "@/redux/slice/location/slice";
import {
  setCartLocation,
  setCartTotalAmount
} from "@/redux/slice/cart/slice";
import { CartItem } from "@/redux/slice/cart/types/CartItem";
import { getGuestCartItemsFromServer, getGuestCartShipments } from "@/redux/slice/cart/utils/getPatientCartItemsFromServer";
import { replaceCartItems } from "@/redux/slice/cart/utils/replaceCartItems";
import { GetGuestCartDetails_getGuestCartDetails as GuestCartDetails } from "@/components/graphql/types/FetchGuestCart";

export const handleFetchGuestCartResponse = async (
  serverCartResponse: GuestCartDetails,
  pathname,
  dispatch
): Promise<void> => {

  const syncDeviceCart = (serverCartItems: CartItem[]): void => {
    try {
      replaceCartItems(serverCartItems, dispatch);
    } catch (syncCartError) {
      console.error("Failed to sync device cart", syncCartError);
    }
  };
  const {
    address,
    groupCards,
    amountBreakdown,
  } = serverCartResponse || {};

  const cartLocation = {
    pincode: address?.zipcode || "",
    lat: Number(address?.coordinate?.latitude || 0),
    lng: Number(address?.coordinate?.longitude || 0),
  };
  const serverCartItems = groupCards?.flatMap((group) => group.products) || [];

  syncDeviceCart(getGuestCartItemsFromServer(serverCartItems));

  if (cartLocation.pincode) {
    dispatch(
      updateSpecifiedLocation({
        city: address?.city || "",
        country: "",
        latitude: cartLocation.lat,
        longitude: cartLocation.lng,
        pincode: cartLocation.pincode,
        state: address?.state || "",
      })
    );
  }

  dispatch(setCartLocation(cartLocation.pincode ? cartLocation : null));
  dispatch(setCartTotalAmount(amountBreakdown?.toPay || 0));
};
